module.exports = __webpack_public_path__ + "assets/img/3-2.ace70cda.jpg";